













import Vue from '@front-app/vendor/vue';
import {
	defineComponent,
	PropType,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: { CtaButton },
	props: {
		tag: {
			type: [String, Object] as PropType<null | string | Vue>,
			default: null,
		},
		isSelected: {
			type: Boolean,
		},
		size: {
			type: String as PropType<Size>,
			default: Size.MEDIUM,
		},
	},
	setup() {
		return {
			Size,
		};
	},
});
